import PaginationComponent from 'components/pagination/pagination-component'
import { useSelector } from 'react-redux'
import { selectArtist } from 'store/artist/selectors'

export default function ArtistPagination({
  onChange,
}: {
  onChange: (i: number) => void
}) {
  const { currentPage, pageSize, totalItem } = useSelector(selectArtist)

  return (
    <div className='wa__pagination'>
      <PaginationComponent
        total={totalItem}
        current={currentPage}
        pageSize={pageSize}
        onChange={(index) => onChange(index)}
      />
    </div>
  )
}
